export function metaTitle(title: string) {
  const prefix = 'KABU&カブ活';
  return `${prefix} | ${title}`;
}
